// src/components/ConfirmationComponent.js
import React, { useEffect }from 'react';
import '../../css/loader.css';
const LoaderComponent = ({isLoading, width, paddingTop}) => {
  useEffect(() => {  
  }, isLoading);
  return (
    <div >
      { isLoading && (
        <div className="loader-container" style={{paddingTop: paddingTop}}>
          <div className="loader" style={{ width: width }}></div>
        </div>
      )}
    </div>
  );
};

export default LoaderComponent;
